import { useEffect } from 'react';

import Spanner from '@gef-ui/components/atoms/SvgIcon/Icons/Spanner';
import { getLabelMessage, getMessage } from '@gef-ui/localization/messages';

import { Panel } from 'components';

export const MigrationInProgress = () => {
	useEffect(() => {
		document.title = getMessage(`common:gkcl${905}`);
	}, []);

	return (
		<div className="Delegations">
			<Panel screenId={905}>
				<div className="MigrationInProgress">
					<div>
						<Spanner className="MigrationIcon" />
					</div>
					<div className="MigrationText">{getLabelMessage('migrationInProgress:migrationText')}</div>
				</div>
			</Panel>
		</div>
	);
};

export default MigrationInProgress;
